import React, { useState } from "react";
import { useAdminCreateCompanyMutation } from "@diditusa/shared/api/adminApi";
import LoadingIndicator from "@diditusa/shared/web_components/LoadingIndicator/loadingIndicator";
import { useNavigate } from "react-router-dom";
import { Box, Button, TextField, Typography, Stack } from "@mui/material";
import "./companies.css";

export default function CompaniesCreate() {
  const [adminCreateCompany, { isLoading, isError, data, error }] =
    useAdminCreateCompanyMutation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [adminName, setAdminName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [licenses, setLicenses] = useState("");
  const [validationMsg, setValidationMsg] = useState("");

  const onCreateClick = async () => {
    if (!name) {
      setValidationMsg("Company name is required");
      return;
    }

    if (!adminEmail) {
      setValidationMsg("Admin name is required");
      return;
    }

    if (!adminEmail) {
      setValidationMsg("Admin email is required");
      return;
    }

    try {
      await adminCreateCompany({
        name,
        adminName,
        adminEmail,
        address,
        phone,
        licenses: licenses.split(","),
      });
      navigate("/companies");
    } catch (err: any) {
      setValidationMsg(err.message || "Failed to create company");
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Add New Company
      </Typography>
      <Stack spacing={3}>
        <TextField
          label="Company Name*"
          placeholder="Enter company name"
          variant="filled"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <TextField
          label="Admin Name*"
          placeholder="Enter admin name"
          variant="filled"
          fullWidth
          value={adminName}
          onChange={(e) => setAdminName(e.target.value)}
        />

        <TextField
          label="Admin Email*"
          placeholder="Enter admin email"
          variant="filled"
          fullWidth
          value={adminEmail}
          onChange={(e) => setAdminEmail(e.target.value)}
        />

        <TextField
          label="Phone Number"
          placeholder="Enter phone number"
          variant="filled"
          fullWidth
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <TextField
          label="Address"
          placeholder="Enter company address"
          variant="filled"
          multiline
          minRows={3}
          fullWidth
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />

        <TextField
          label="License Numbers"
          placeholder="Enter a comma-separated list of license numbers"
          variant="filled"
          multiline
          minRows={3}
          fullWidth
          value={licenses}
          onChange={(e) => setLicenses(e.target.value)}
        />
        <Typography variant="subtitle1">{validationMsg}</Typography>
      </Stack>
      <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          color="secondary"
          sx={{ borderRadius: 8, px: 4 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: 8, px: 4 }}
          onClick={onCreateClick}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
}
